function causa(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Covid-19 é uma doença infecciosa causada por um vírus denominado SARS-CoV-2, conhecido também como novo coronavírus",
						"title":"Quem causa a doença Covid-19",
						"image":"images/games/informs/causa/1.png",
					},
					{
						"text":"Os sintomas da doença costumam surgir entre cinco ou seis dias após o contato com o vírus. Porém, esse período pode variar de um a quatorze dias.",
						"title":"Quem causa a doença Covid-19",
						"image":"images/games/informs/causa/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/causa/1.png"
			}
		]
	};
}

export {causa};
